import { defineStore } from 'pinia'
import { ref } from 'vue'
import api from '../lib/api'

export const useRepassesStore = defineStore('repasses', () => {
  const items = ref([])
  const resumo = ref([])
  const loading = ref(false)

  async function fetchAll(eventoId) {
    loading.value = true
    try {
      const { data } = await api.get('/repasses', { params: eventoId ? { eventoId } : {} })
      items.value = data.repasses
    } finally { loading.value = false }
  }

  async function fetchResumo() {
    loading.value = true
    try {
      const { data } = await api.get('/eventos/resumo')
      resumo.value = data.eventos
    } finally { loading.value = false }
  }

  async function registrar(payload) {
    const { data } = await api.post('/repasses', payload)
    items.value = [data.repasse, ...items.value]
    return data.repasse
  }

  async function remover(id) {
    await api.delete(`/repasses/${id}`)
    items.value = items.value.filter(r => r.id !== id)
  }

  return { items, resumo, loading, fetchAll, fetchResumo, registrar, remover }
})
